export const ID_KEY = 'id';

export const LEVEL_KEY = 'level';

export const FIRST_NAME_KEY = 'first_name';

export const LAST_NAME_KEY = 'last_name';

export const PHONE_KEY = 'phone';
